import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PanelCards } from '../../Panel';
import { setActiveSubLayer } from '../../../actions/layersActions';
import {
  activeImportedShapefileSelector,
  importedShapefilePropertiesSelector,
} from '../../../selectors/mosaicSelectors';
import { FHA, HARVEST, PLANTING, WEATHER } from '../../../constants/cards';
import { reqImportedShapefileData } from '../../../actions/mosaicActions';
import { IMPORTED_SHAPEFILE } from '../../../constants/mapLayerIds';
// eslint-disable-next-line max-len
import ImportedShapefileCard from '../../../components/cards/ImportedShapefile/ImportedShapefileCard';
// eslint-disable-next-line max-len
import ImportedShapefilePreview from '../../../components/cards/ImportedShapefile/ImportedShapefilePreview';

const CARDS = [WEATHER, PLANTING, HARVEST, FHA];

export class ImportedShapefilePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePropertyIndex: 0,
    };
  }

  componentDidMount() {
    const {
      properties,
      activeShapefile,
      userId,
      reqImportedShapefileData: reqImportedShapefileDataProp,
    } = this.props;
    if (!properties || properties.length === 0) {
      reqImportedShapefileDataProp(
        activeShapefile.fieldId,
        userId,
        activeShapefile.eventDate,
        activeShapefile.uuid
      );
    }
  }

  setActivePropertyIndex = (e) => {
    const newActivePropertyIndex = parseInt(e.currentTarget.id, 10);
    this.setState({
      activePropertyIndex: newActivePropertyIndex,
    });
  };

  decrementPropertyIndex = () => {
    const { properties } = this.props;
    const { activePropertyIndex } = this.state;
    const newIndex =
      activePropertyIndex === 0
        ? properties.length - 1
        : activePropertyIndex - 1;
    this.setActivePropertyIndex({ currentTarget: { id: newIndex } });
  };

  incrementPropertyIndex = () => {
    const { properties } = this.props;
    const { activePropertyIndex } = this.state;
    const newIndex =
      activePropertyIndex >= properties.length - 1
        ? 0
        : activePropertyIndex + 1;
    this.setActivePropertyIndex({ currentTarget: { id: newIndex } });
  };

  render() {
    const {
      activeShapefile,
      index,
      isCollapsed,
      isSplitViewEnabled,
      properties,
      locale,
    } = this.props;
    const { activePropertyIndex } = this.state;
    const activeProperty =
      properties && (properties[activePropertyIndex] || null);
    const headerDetail = activeProperty && activeShapefile.filename;
    const firstCard =
      isSplitViewEnabled && isCollapsed ? (
        <ImportedShapefilePreview
          activeProperty={activeProperty}
          activeShapefile={activeShapefile}
          isLoading={!properties}
          locale={locale}
          onLeftClick={this.decrementPropertyIndex}
          onRightClick={this.incrementPropertyIndex}
        />
      ) : (
        <ImportedShapefileCard
          activeProperty={activeProperty}
          activePropertyIndex={activePropertyIndex}
          activeShapefile={activeShapefile}
          locale={locale}
          onClick={this.setActivePropertyIndex}
          properties={properties}
        />
      );

    return (
      <PanelCards
        cards={CARDS}
        firstCard={firstCard}
        headerDetail={headerDetail}
        index={index}
        isCollapsed={isCollapsed}
        testId={IMPORTED_SHAPEFILE}
      />
    );
  }
}

ImportedShapefilePanel.propTypes = {
  activeShapefile: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isCollapsed: PropTypes.bool,
  isSplitViewEnabled: PropTypes.bool.isRequired,
  locale: PropTypes.string,
  properties: PropTypes.array,
  reqImportedShapefileData: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  return {
    activeShapefile: activeImportedShapefileSelector(state),
    locale: state.app.locale,
    userId: state.user.id,
    properties: importedShapefilePropertiesSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveSubLayer,
      reqImportedShapefileData,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportedShapefilePanel);
